module.exports = __webpack_public_path__ + "static/media/mainimg-10.e45a5b31.png";